// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1BzVE","dragIcon":"SortableItem_dragIcon__3OZMI","disabled":"SortableItem_disabled__xAXBR"};